import { Avatar, AvatarProps } from "@files-ui/react";
import defautAvatarSrc from "assets/images/default-avatar.jpg";
export const XAvatar = (props: AvatarProps) => {
  return (
    <Avatar
      {...props}
      src={props.src ? props.src : defautAvatarSrc}
      alt="Avatar"
      onChange={props.onChange}
      smartImgFit={props.smartImgFit || "orientation"}
      emptyLabel={"Chọn ảnh ..."}
      changeLabel={"Chọn ảnh ..."}
      loadingLabel={"Đang tải ..."}
    />
  );
};
